import React from 'react';
import { Container } from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import { Link } from 'react-router-dom';
import ListInvites from './ListInvites';
import ListTeamMembers from './ListTeamMembers';
import TeamMemberPageWrapper from './TeamMemberPageWrapper';
import { TEAM_MEMBER_FULL_PATH } from 'constants/paths';
import Team from './Team';
import { useSelector } from 'react-redux';
import useWhiteLabel from 'hooks/useWhiteLabel';

function TeamMember() {
  const { me } = useSelector((state) => state.auth);

  const { isWhiteLabelTeam } = useWhiteLabel();

  return (
    <TeamMemberPageWrapper>
      <SimpleHeader
        name="Company"
        description={`Use this area to invite members to your ${!isWhiteLabelTeam ? 'Gather ' : ''}portal, so you can collaborate and review analysed data in the Dashboard.
Also here, if your members have their access level set to "Member" you can set their privileges as to what they can see.<br />
By example if you have created a "locations" data set in your Preset Data, by using the edit button on the right, you can set which managers see which locations.`}
        firstColProps={{ xs: 4 }}
        secondColProps={{ xs: 8 }}
        rightElements={
          me?.level === 'ADMIN' ? (
            <Link
              to={`${TEAM_MEMBER_FULL_PATH}/invite`}
              className="btn btn-neutral btn-sm rounded-pill">
              Invite a Company Member
            </Link>
          ) : null
        }
      />
      <Container className="mt--6" fluid>
        {me?.level === 'ADMIN' && <Team />}
        <ListTeamMembers />
        <ListInvites />
      </Container>
    </TeamMemberPageWrapper>
  );
}

export default TeamMember;
